import React from "react";

import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { Link } from "react-router-dom";
import Masonry from "react-masonry-css";
import { selectAllLoads } from "../../redux/load/load.selectors";

import ReqCard from "../../components/ReqCard/ReqCard.component";

import { CardList } from "./ReqCardsList.styles";

const ReqCardsList = ({ reqs }) => {
  const breakpointColumnsObj = {
    default: 7,
    2300: 6,
    1750: 5,
    1450: 4,
    1280: 3,
    992: 2,
    600: 1,
  };
  // console.log("reqcardslist container");
  // debugger;
  return (
    <CardList className="justify-content-center justify-content-md-between">
      {/* {console.log(reqs[2].source_location._shahr)} */}
      <Masonry
        breakpointCols={breakpointColumnsObj}
        className="my-masonry-grid"
        columnClassName="my-masonry-grid_column"
      >
        {
          reqs?.map((item) => (
            <Link
              to={`/load/${item.Custom_id}?=درخواست_بار_${
                item.source_location
                  ? item.source_location._ostan.provincename
                  : null
              }_${
                item.source_location
                  ? item.source_location._shahr.shahrname
                  : null
              }_به_${
                item.destination_location
                  ? item.destination_location._ostan.provincename
                  : null
              }_${
                item.destination_location
                  ? item.destination_location._shahr.shahrname
                  : null
              }`}
              key={item.id}
            >
              <ReqCard reqInfo={item} />
            </Link>
          ))
          // : null
        }
      </Masonry>
    </CardList>
  );
};

const mapStateToProps = createStructuredSelector({
  reqs: selectAllLoads,
});

export default connect(mapStateToProps)(ReqCardsList);
